export default __webpack_public_path__ + "static/media/hackathon.ed630e2a.png";